import { ChannelKind, ChannelKindType } from 'shared/entities/channels';

import { CustomEmojiHintKind } from '../client';

/**
 * Возможность отправки custom emoji определяет Telegram и только для своего бота:
 * у каналов других мессенджеров, в том числе у Telegram через Jivo или Wazzup,
 * `custom_emoji_supported` не приходит, и получатель всегда видит обычные замены.
 */
export const getCustomEmojiHintKind = ({
  channelKind,
  customEmojiSupported,
  parseMarkdown = false
}: {
  /** Канал диалога; `null` — редактор блока сценария, диалога нет */
  channelKind: ChannelKindType | null;
  /** `custom_emoji_supported` Telegram-канала; `null` — отправок ещё не было */
  customEmojiSupported: boolean | null;
  /** Галочка Markdown в блоке: такой блок отправляет обычные замены во все каналы */
  parseMarkdown?: boolean;
}): CustomEmojiHintKind => {
  if (channelKind === null) {
    return parseMarkdown
      ? CustomEmojiHintKind.scenarioBlockMarkdown
      : CustomEmojiHintKind.scenarioBlock;
  }

  if (channelKind !== ChannelKind.TELEGRAM) {
    return CustomEmojiHintKind.otherMessenger;
  }

  if (customEmojiSupported === null) {
    return CustomEmojiHintKind.telegramUnknown;
  }

  return customEmojiSupported
    ? CustomEmojiHintKind.telegramSupported
    : CustomEmojiHintKind.telegramUnsupported;
};
